// Deployment constants for the add-in. The OAuth client was registered against
// crm.clswind.com via dynamic client registration (public client, PKCE).

export const TWENTY_BASE_URL = 'https://crm.clswind.com';

// Production OAuth client (DCR-registered 2026-06-17). Public client, no secret.
// Registered redirects: prod (crm-addin.clswind.com) + https://localhost:3000 (dev).
export const OAUTH_CLIENT_ID = 'dedbe234-f10c-400c-af53-7fbe157c398e';
export const OAUTH_REDIRECT_URI =
  'https://crm-addin.clswind.com/auth-callback.html';
export const OAUTH_SCOPES = 'api profile';

// The org's own domain(s). Internal correspondence does NOT create CRM People
// or Companies - colleagues aren't prospects and we don't want a "clswind.com"
// company. (The message itself is still created if the user logs it.)
export const ORG_DOMAINS = ['clswind.com'];

// The dedicated "Logged via Outlook" message channel, provisioned directly in
// the core schema on 2026-06-19. Logged emails are written as NATIVE Twenty
// messages associated to this channel, so they appear in the built-in Emails
// tab on Person/Company records. The channel is a core engine entity and is NOT
// queryable via the workspace API, so the id is a constant here. It is not a
// secret. visibility=SHARE_EVERYTHING (whole team sees logged emails), sync off.
export const LOGGED_EMAIL_CHANNEL_ID = '81d6e9ac-a5ad-4db0-9a50-09a34bd3502e';

// Microsoft Entra app registration for the "Log thread" feature. The add-in uses
// Nested App Authentication (NAA) via MSAL to get a delegated Microsoft Graph
// token (Mail.Read) so it can read the other messages in the open conversation.
// Single tenant; admin-consented. Not secrets (public SPA client). The SPA
// redirect "brk-multihub://crm-addin.clswind.com" must be registered on the app.
export const GRAPH_CLIENT_ID = '5bdc2840-3df0-4387-9ca5-ee8006076c01'; // Application (client) ID
export const GRAPH_TENANT_ID = '9c8722be-d9ca-4a8d-8da8-d50fb2912d3c'; // Directory (tenant) ID
